<p>error-camera works!</p>
